import { CDN_UPLOAD_URL } from "@config";
import { GAS_STATION_KEY } from "@store/memberCenterSlice";
import { GasStation } from "./types";
import { Trans } from "react-i18next";

export const gasStation: {
  [key in GAS_STATION_KEY]: GasStation;
} = {
  "AI.CREDITS": {
    title: "Credits",
    mark: (
      <>
        <span className="font-bold">100</span>
        <Trans>Credits</Trans>
      </>
    ),
    icon: `${CDN_UPLOAD_URL}/upload/0618c2e5.png`,
    background: "linear-gradient(91.48deg, #E6E6F3 20.52%, #FFFFFF 108.15%)",
    price: {
      ID: 160330,
      MY: 44.33,
      TH: 339,
      VN: 252034,
      PH: 578.62,
      US: 9.99,
      GB: 8,
      SG: 13.5,
      MX: 202.1,
      DE: 9.0,
      FR: 9.0,
      IT: 9.0,
      ES: 9.0,
      BR: 55.9,
      JP: 1399.0,
      CN: 71.93,
    },
    unit: (
      <>
        <span>100</span>
        <Trans>Credits</Trans>
      </>
    ),
  },
  "DOWNLOAD.VIDEO": {
    title: "Video Download",
    mark: "10 times",
    icon: `${CDN_UPLOAD_URL}/upload/f3e14eb3.png`,
    background: "linear-gradient(91.48deg, #E6E6F3 20.52%, #FFFFFF 108.15%)",
    price: {
      ID: 9500,
      MY: 2.8,
      TH: 21,
      VN: 14000,
      PH: 33,
      US: 0.59,
      GB: 0.5,
      SG: 0.79,
      MX: 11.9,
      DE: 0.5,
      FR: 0.5,
      IT: 0.5,
      ES: 0.5,
      BR: 3.3,
      JP: 99.0,
      CN: 4.25,
    },

    unit: "One Batch",
  },
  "ACCOUNT.SUBCOUNT": {
    title: "Sub-Account",
    mark: "1 month",
    background: "linear-gradient(91.48deg, #FFF5E1 20.52%, #FFFFFF 108.15%)",
    icon: `${CDN_UPLOAD_URL}/upload/9552186b.png`,
    price: {
      ID: 950000,
      MY: 279,
      TH: 2190,
      VN: 1400000,
      PH: 3354,
      GB: 47.3,
      SG: 80.3,
      MX: 1211.8,
      DE: 53.9,
      FR: 53.9,
      IT: 53.9,
      ES: 53.9,
      BR: 335.4,
      JP: 8499.0,
      CN: 119.0,
      //    US: 59.9, 中国 对应的美元是 16.5 从接口获取
    },
    unit: "One",
  },
  REPORT: {
    title: "Customized Data Report",
    mark: "",
    background: "", //"linear-gradient(91.48deg, #E7ECF8 20.52%, #FFFFFF 108.15%)",
    icon: "", //`${CDN_UPLOAD_URL}/upload/46806e1b.png`,
    price: {
      ID: 3100000,
      MY: 899,
      TH: 6990,
      VN: 4700000,
      PH: 11144,
      US: 199,
      GB: 157.2,
      SG: 266.7,
      MX: 7242.3,
      DE: 322.2,
      FR: 322.2,
      IT: 322.2,
      ES: 322.2,
      BR: 2004.8,
      JP: 51999.0,
      CN: 1857.6,
    },
    unit: "One Report",
  },
  "LIVESTREAM.FULL_RECORD": {
    title: "Live Record",
    mark: "5 times",
    background: "linear-gradient(91.48deg, #FEE3E8 20.52%, #FFFFFF 108.15%)",
    icon: `${CDN_UPLOAD_URL}/upload/ea93976e.png`,
    price: {
      ID: 62500,
      MY: 25,
      TH: 150,
      VN: 97500,
      PH: 250,
      US: 3.99,
      GB: 3.2,
      SG: 5.35,
      MX: 80.7,
      DE: 3.6,
      FR: 3.6,
      IT: 3.6,
      ES: 3.6,
      BR: 22.3,
      JP: 499.0,
      CN: 5.69,
    },
    unit: "One Batch",
  },
  "DATA.EXPORT.NUM": {
    title: "Data export fuel package",
    mark: "1000 items",
    background: "linear-gradient(91.48deg, #E6E6F3 20.52%, #FFFFFF 108.15%)",
    icon: `${CDN_UPLOAD_URL}/upload/b0fa27e5.png`,
    price: {
      ID: 259000,
      MY: 529000,
      TH: 540.6,
      VN: 67,
      PH: 908,
      GB: 55.9,
      MX: 1400.0,
      BR: 390.0,
      JP: 2999,
      CN: 42.48,
      SG: 20.4,

      // 欧洲都用欧元
      DE: 62.9,
      FR: 62.9,
      IT: 62.9,
      ES: 62.9,
      // US: 15.9, 69.9 5.9 19.9 从接口获取 动态的价格
    },
    unit: "One Report",
  },
  "CUSTOMIZED.DATA.EXPORT": {
    title: "Creator contacts export",
    mark: "1000 items",
    background: "linear-gradient(91.48deg, #E6E6F3 20.52%, #FFFFFF 108.15%)",
    icon: `${CDN_UPLOAD_URL}/upload/d6e263e4.png`,
    price: {
      ID: 359000,
      MY: 599000,
      TH: 676.6,
      VN: 85,
      PH: 1142,
      GB: 55.9,
      MX: 1400.0,
      BR: 390.0,
      JP: 2999,
      CN: 64,
      SG: 25.4,
      // 欧洲都用欧元
      DE: 62.9,
      FR: 62.9,
      IT: 62.9,
      ES: 62.9,
      // SG: 266.7,
      // US: 19.9, 69.9 8.9 19.9 从接口获取 动态的价格
    },
    unit: "One Report",
  },
};

export const DURATION_MAP = {
  Monthly: "Month",
  Yearly: "Year",
};
